<div class="row">
  <div class="col-md-12">
    <h2>Dealer Report Search</h2>
  </div>
</div>
<form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label for="purchaseDate">Purchase Date</label>
        <div class="input-group">
          <input
            type="text"
            id="purchaseDate"
            formControlName="purchaseDate"
            placeholder="mm/dd/yyyy"
            class="form-control required"
            aria-required="true"
            ngbDatepicker
            #d="ngbDatepicker"
            [firstDayOfWeek]="7"
            [showWeekNumbers]="true"
            [navigation]="'arrows'"
            [ngClass]="{'is-invalid': searchForm.get('purchaseDate').errors && searchForm.get('purchaseDate').touched}">
          <div class="input-group-append">
            <button type="button" class="input-group-text" (click)="d.toggle()" aria-label="Open date picker">
              <i class="fas fa-calendar"></i>
            </button>
          </div>
        </div>

        <div *ngIf="searchForm.get('purchaseDate').errors && searchForm.get('purchaseDate').touched" role="alert"
             class="formError text-danger" aria-live="assertive">
          Please, enter a valid Purchase Date.
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label for="fishermanLicense">Fisherman License</label>
        <input type="text"
               formControlName="fishermanLicense"
               name="fishermanLicense"
               id="fishermanLicense"
               class="form-control required"
               aria-required="true"
               aria-label="Fisherman License"
               [attr.aria-invalid]="searchForm.get('fishermanLicense').errors && searchForm.get('fishermanLicense').touched"
               [ngClass]="{'is-invalid': searchForm.get('fishermanLicense').errors && searchForm.get('fishermanLicense').touched}">
        <div *ngIf="searchForm.get('fishermanLicense').errors  && searchForm.get('fishermanLicense').touched" role="alert"
             class="formError text-danger" aria-live="assertive">
          Please, enter a valid License Number.
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="searchForm.hasError('tooManyResults')" class="alert alert-danger" role="alert">
    <span> The number of search results exceeded the upper limit. Please refine your search.</span>
  </div>
  <div *ngIf="searchForm.hasError('noResultsFound')" class="alert alert-danger" role="alert">
    <span> No results found. Please edit your search.</span>
  </div>

  <div class="row">
    <div class="col-md-6">
      <button [disabled]="!searchForm.valid" type="submit" class="btn btn-primary mb-3 mr-2"><i class="fas fa-search"></i> Search</button>
      <button type="button" class="btn btn-danger mb-3" (click)="onStartNewSearch()"><i class="fas fa-redo"></i> Reset
      </button>
    </div>
    <div *appHasAuthority="'MANAGE_REPORT'" class="col-md-3">
      <button class="btn btn-primary btn-block mb-3" (click)="addPaperReport()">
        <i class="fas fa-plus"> </i>&nbsp;Add Paper Report
      </button>
    </div>
    <div *appHasAuthority="'MANAGE_REPORT'" class="col-md-3">
      <button class="btn btn-primary btn-block mb-3" (click)="addPaperCredit()">
        <i class="fas fa-plus"> </i>&nbsp;Add Paper Credit
      </button>
    </div>

  </div>
</form>
<div *ngIf="isSearchPerformed" class="ng-scope" style=""><br>
  <h3>Search Results</h3>
  <div class="row">
    <div class="col-md-12">

      <table *ngIf="searchResults?.length" class="table">
        <thead class="thead-dark">
        <tr>
          <th>Date</th>
          <th>Fisher</th>
          <th>License #</th>
          <th>Amount</th>
          <th>Type</th>
          <th>Submitted By</th>
          <th>Submitted On</th>
          <th *appHasAuthority="'DEALER_INFO'">Approval Status</th>
          <th class="buttons-column">Action</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let report of searchResults">
          <tr>
            <td>{{report.reportDate | date:'mediumDate'}}</td>
            <td>{{report.sellerName}}</td>
            <td>{{report.sellerId}}</td>
            <td>{{report.amount | bigCurrency}}</td>
            <td>
              <ng-container [ngSwitch]="report.reportType">
                <strong *ngSwitchCase="ReportType.P">Purchase</strong>
                <strong *ngSwitchCase="ReportType.PAQ">Purchase-AQ</strong>
              </ng-container>
            </td>
            <td>{{report.submittedBy}}</td>
            <td>{{report.submittedOn | date:'mediumDate'}}</td>
            <td *appHasAuthority="'DEALER_INFO'">
              <strong *ngIf="report.deleted" class="rpt-tp-dnp">DELETED</strong>
              <ng-container *ngIf="!report.deleted">
                <select *appHasAuthority="'MANAGE_REPORT'" class="form-control form-control-sm"  aria-label="status"
                        (change)="onStatusChange(report.id, $event.target.value)">
                  <option></option>
                  <option [selected]="ApprovalStatus.APPROVED == report.status" [value]="ApprovalStatus[ApprovalStatus.APPROVED]">{{ApprovalStatus.meaning(ApprovalStatus.APPROVED)}}</option>
                  <option [selected]="ApprovalStatus.PENDING == report.status" [value]="ApprovalStatus[ApprovalStatus.PENDING]">{{ApprovalStatus.meaning(ApprovalStatus.PENDING)}}</option>
                  <option [selected]="ApprovalStatus.NO_RESPONSE == report.status" [value]="ApprovalStatus[ApprovalStatus.NO_RESPONSE]">{{ApprovalStatus.meaning(ApprovalStatus.NO_RESPONSE)}}</option>
                </select>
                <span *appHasNoAuthority="'MANAGE_REPORT'">{{ApprovalStatus.meaning(report.status)}}</span>
              </ng-container>
            </td>
            <td>
              <div class="odr-btn-group" role="group" aria-label="Report actions">
                <button (click)="onOpenPurchaseReceiptReport(report.id, report.submittedBy, periodIndex)" class="btn btn-primary btn-sm mr-1"><i class="far fa-eye"> </i> <span *appHasNoAuthority="'DEALER_INFO'"> View report</span><span *appHasAuthority="'DEALER_INFO'"> View</span></button>
<!--                <ng-container *appHasAuthority="'MANAGE_REPORT'">-->
<!--                  <button *ngIf="!report.deleted" (click)="deleteReceiptReport(report.id, periodIndex)" class="btn btn-danger btn-sm"><i class="fas fa-trash"> </i> Delete </button>-->
<!--                </ng-container>-->
              </div>
            </td>
          </tr>
<!--          <tr *ngIf="showDeleteWarning == report.id" class="alert alert-danger">-->
<!--            <td colspan="9">-->
<!--              <div >-->
<!--                <span>Are you sure you want to delete this report? To confirm, click delete again.</span>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
        </ng-container>
        </tbody>
      </table>


    </div>
  </div>
</div>
